import { QueryClient, QueryCache, MutationCache } from '@tanstack/react-query';
import { logger } from '@/lib/logger';

export const queryClientInstance = new QueryClient({
	queryCache: new QueryCache({
		onError: (error, query) => {
			logger.error(error, { source: 'react-query', queryKey: query.queryKey });
		},
	}),
	mutationCache: new MutationCache({
		onError: (error) => {
			logger.error(error, { source: 'react-query-mutation' });
		},
	}),
	defaultOptions: {
		queries: {
			staleTime: 30 * 1000, // 30 seconds
			refetchOnWindowFocus: false,
			retry: 1,
		},
	},
});